module.exports = __webpack_public_path__ + "img/belize.227fc34.webp";